<ng-container *ngIf="controlState$ | async as controlState">
  <small *ngIf="controlState.showError && (controlState.errorMessage || customErrorMessage)" class="p-error" [class.italic]="italic">
    {{ customErrorMessage ?? controlState.errorMessage }}
  </small>
</ng-container>
